"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Memory = require("./Memory");

var _Memory2 = _interopRequireDefault(_Memory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Represents a page of Memories
 * @param {Object} page response object
 */
class LocationsPage {
  constructor(fields) {
    if (!fields) {
      return;
    }

    if (fields.items) {
      this.items = fields.items.map(item => new _Memory2.default(item));
    }

    if (fields.count) {
      this.count = fields.count;
    }

    if (fields.lastKey) {
      this.lastKey = fields.lastKey;
    }
  }
}
exports.default = LocationsPage;